import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setProgress, setToast } from "../../../redux/slice/system";
import { ContractAPI } from "../../../axios/api";
import { useAbortedEffect, useHookForm } from "../../../components/hooks";

import ModuleBreadCrumb from "../../../components/breadCrumb";
import {
  FormInputtext,
  FormInputtextarea,
} from "../../../components/formElement/index";
import { formatResData, checkFormUpdate } from "../../../service/common";

import { Button } from "primereact/button";
import { classNames } from "primereact/utils";

export default function BackContractDetail() {
  const route_params = useParams();
  const route_navigate = useNavigate();
  const dispatch = useDispatch();
  const crumbItem = [
    {
      key: 1,
      label: "提問管理",
      command: () => route_navigate("/back/contract"),
    },
    {
      key: 2,
      label: "編輯",
    },
  ];
  const [reload, setReload] = useState({
    list: true,
  });
  const disabled = false;
  // 明細資料
  const [apiData, setApiData] = useState({});
  // 表單欄位預設值
  const defaultValues = {
    member_name: null,
    createdatetime: "",
    question: "",
    answer: "",
  };
  const { handleSubmit, reset, trigger, yup, setSchema, errors, setting } =
    useHookForm({
      defaultValues,
    });

  useEffect(() => {
    setSchema(
      yup
        .object({
          question: yup.string().required("必填"),
          answer: yup.string().required("必填"),
        })
        .required()
    );
  }, []);

  useAbortedEffect(
    (signal) => {
      if (!reload.list || route_params.detailid === "add") {
        return;
      }

      dispatch(setProgress(true));

      let params = { id: route_params.detailid };

      ContractAPI.getQuestionAndAnswerMemberDetails({
        data: params,
        options: { signal },
      }).then((result) => {
        let { Response, data, message } = result;

        if (Response === 1) {
          let temp = formatResData(defaultValues, data);
          setApiData(temp);
          reset(temp);
          setReload((state) => ({ ...state, list: false }));
        } else {
          dispatch(
            setToast({
              severity: "error",
              summary: message,
              detail: "",
            })
          );
        }

        dispatch(setProgress(false));
      });
    },
    [reload]
  );

  // 表單驗證成功後，呼叫 API
  const onSubmit = (submitData) => {
    dispatch(setProgress(true));

    let jsonData = {
      // ...submitData,
      answer: submitData.answer,
    };

    if (!checkFormUpdate(jsonData, apiData)) {
      dispatch(
        setToast({
          severity: "warn",
          summary: "無資料變更",
          detail: "",
        })
      );
      dispatch(setProgress(false));
      route_navigate("/back/contract");
      return;
    }

    let promise,
      toast = "";
    if (route_params.detailid === "add") {
      // 新增
      promise = ContractAPI.setQuestionAndAnswerMember({
        data: jsonData,
      });
      toast = "新增";
    } else {
      // 修改
      delete jsonData.username;
      jsonData.id = Number(route_params.detailid);
      promise = ContractAPI.updateQuestionAndAnswerMember({
        data: jsonData,
      });
      toast = "編輯";
    }

    promise.then((result) => {
      let { Response, message } = result;

      if (Response === 1) {
        dispatch(
          setToast({
            severity: "success",
            summary: `${toast}成功`,
            detail: "",
          })
        );
        route_navigate("/back/contract");
      } else {
        dispatch(
          setToast({
            severity: "error",
            summary: `${toast}失敗`,
            detail: message ?? "",
          })
        );
        dispatch(setProgress(false));
      }
    });
  };

  return (
    <>
      <ModuleBreadCrumb crumbItem={crumbItem} />

      <h2 className="my-3 ml-1">提問管理 - 編輯</h2>

      <div className="border-round-lg bg-white mt-3 p-3">
        <form onSubmit={handleSubmit(onSubmit)} className="formgrid grid">
          <div className="flex flex-column align-items-start sm:flex-row field col-12">
            <label
              htmlFor="member_name"
              className={classNames(
                { "p-error": errors.member_name },
                "col-12 sm:col-2 text-left sm:text-right mb-1 sm:mb-0 sm:mt-2"
              )}
            >
              <span className="text-red-400 mr-1">*</span>
              會員
            </label>
            <div className="col-12 sm:col-10 lg:col-5 md:col-8">
              <FormInputtext
                setting={setting}
                data={{
                  name: "member_name",
                  disabled: true,
                }}
              />
            </div>
          </div>

          <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12">
            <label
              htmlFor="createdatetime"
              className={classNames(
                { "p-error": errors.createdatetime },
                "col-12 sm:col-2 text-left sm:text-right mb-1 sm:mb-0"
              )}
            >
              提問時間
            </label>
            <div className="col-12 sm:col-10 lg:col-5 md:col-8">
              <FormInputtext
                setting={setting}
                data={{
                  name: "createdatetime",
                  disabled: true,
                }}
              />
            </div>
          </div>

          <div className="flex flex-column align-items-start sm:flex-row field col-12">
            <label
              htmlFor="question"
              className={classNames(
                { "p-error": errors.question },
                "col-12 sm:col-2 text-left sm:text-right mb-1 sm:mb-0 sm:mt-2"
              )}
            >
              <span className="text-red-400 mr-1">*</span>
              問題
            </label>
            <div className="col-12 sm:col-10 lg:col-5 md:col-8">
              <FormInputtextarea
                setting={setting}
                data={{
                  name: "question",
                  rows: 10,
                  disabled: true,
                }}
              />
            </div>
          </div>

          <div className="flex flex-column align-items-start sm:flex-row field col-12">
            <label
              htmlFor="answer"
              className={classNames(
                { "p-error": errors.answer },
                "col-12 sm:col-2 text-left sm:text-right mb-1 sm:mb-0 sm:mt-2"
              )}
            >
              <span className="text-red-400 mr-1">*</span>
              回覆
            </label>
            <div className="col-12 sm:col-10 lg:col-5 md:col-8">
              <FormInputtextarea
                setting={setting}
                data={{
                  name: "answer",
                  rows: 15,
                }}
              />
            </div>
          </div>

          <div className="field col-12 text-right">
            <Button
              type="button"
              label="取消"
              className="p-button-secondary p-button-outlined ml-auto px-3"
              onClick={() => route_navigate("/back/contract")}
            />
            {!disabled && (
              <Button type="submit" label="儲存" className="ml-2 px-3" />
            )}
          </div>
        </form>
      </div>
    </>
  );
}
